import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import { publicCrosswalk1, recommendationEdge, recommendationSwitch } from '@assets/images/solution/recommendation';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/publicCrosswalk/img/1.avif';
import image2 from '@src/assets/images/solution/publicCrosswalk/img/2.avif';
import image3 from '@src/assets/images/solution/publicCrosswalk/img/3.avif';
import image4 from '@src/assets/images/solution/publicCrosswalk/img/4.avif';
import image5 from '@src/assets/images/solution/publicCrosswalk/img/5.avif';
import image6 from '@src/assets/images/solution/publicCrosswalk/img/6.avif';
import image7 from '@src/assets/images/solution/publicCrosswalk/img/7.avif';
import recommendation from '../common/recommendation';
export default {
  type: '都市安全ソリューション',

  recommend: {
    title: '',
    desc: 'ORBRO OSはリアルタイム位置追跡とスマートモニタリング向けの強力なプラットフォームです。<br/>BLE、UWB、AIベースのビデオ解析技術を完全統合し、都市環境での安全性、効率性、拡張性を高めます。',
    labels: {
      desktop: [
        { img: publicCrosswalk1, data: recommendation.ptzCamera },
        { img: recommendationEdge, data: recommendation.edgeRtls },
        { img: recommendationSwitch, data: recommendation.switch },
      ],
      mobile: [{ data: recommendation.ptzCamera }, { data: recommendation.edgeAi }, { data: recommendation.switch }],
    },
  },

  banner: {
    title: '横断歩道での事故を防ぎ、歩行者の安全を守ります。',
    desc: 'AIが車両と歩行者の動きを検知し、衝突の危険がある場合は即座にLED表示板とスピーカーで警告を発します。',
  },

  numOfCard: {
    title: 'AIで横断歩道の事故をゼロに。',
    desc: 'リアルタイムで対象を検出し、双方向警告を発信することで、右折交差点の歩行者事故を完全に防ぎます。',
    card: [
      {
        tag: '99.9%',
        title: '物体認識精度',
        desc: '歩行者、自転車、キックスクーターなどを高精度で検出。',
      },
      {
        tag: '100+',
        title: '同時認識可能な物体数',
        desc: '複数の対象をリアルタイムに追跡可能。',
      },
      {
        tag: '0',
        title: '導入以降の死亡事故',
        desc: '右折交差点での死亡事故はゼロ。',
      },
      {
        tag: '0',
        title: '導入以降の負傷事故',
        desc: '警告後の衝突は一件もなし。',
      },
    ],
  },

  func: [
    {
      theme: '車と歩行者との衝突リスクを的確に検知し、即時に警告。',
      title: 'リアルタイムAIによる車両・歩行者解析',
      desc: 'AIが車両と歩行者の位置、速度、方向をリアルタイムに判定。子ども、ベビーカー、自転車、キックスクーターなども視界が制限された場所でも正確に検出します。',
      sub1: '高精度検知',
      icon1: IconRulerGray,
      sub2: 'リアルタイム状態モニタリング',
      icon2: IconClockGray,
      image: image2,
    },
    {
      title: '位置と進行方向に基づく衝突リスク判断',
      desc: '軌跡、速度、方向を解析し、経路が交差または至近距離の場合にのみ警告を発信。高い精度で安全性を確保します。',
      sub2: 'リアルタイム位置追跡',
      icon1: IconBinocularsGray,
      sub1: '高速データ同期',
      icon2: IconTvocGray,
      image: image3,
    },
    {
      title: 'LED表示板＆スピーカーによる双方向警告',
      desc: '交差点の両側に設置されたディスプレイはドライバーに歩行者の接近を、スピーカーは歩行者に車両の接近を警告します。双方向での情報伝達が事故リスクを大きく低減します。',
      sub1: 'リアルタイム位置追跡',
      icon1: IconBinocularsGray,
      sub2: '高精度検知',
      icon2: IconRulerGray,
      image: image4,
    },
    {
      theme: '効率的な構築と簡単な運用管理で最適な安全性を提供。',
      title: 'データを保護するエッジAIによる独立処理',
      desc: '現場にエッジサーバーを設置し、データ漏洩を防止。オンプレミス運用によりプライバシーと効率的な管理を両立します。',
      sub1: '柔軟なゾーン設定',
      icon1: IconZoneGray,
      sub2: '複数ゾーン対応',
      icon2: IconTagGray,
      image: image5,
    },
    {
      title: '事故多発エリアへのカスタム設置が可能',
      desc: '事故が多発する交差点やスクールゾーンなど、地域に応じたAI映像解析システムの導入が可能です。',
      sub1: '柔軟なゾーン設定',
      icon1: IconZoneGray,
      sub2: '複数ゾーン対応',
      icon2: IconTagGray,
      image: image6,
    },
    {
      title: '様々なメーカーのカメラとの連携に対応',
      desc: '複数メーカーに対応し既存インフラを活用できるため、将来的な拡張や更新も容易です。',
      sub1: '柔軟なゾーン設定',
      icon1: IconZoneGray,
      sub2: '複数ゾーン対応',
      icon2: IconTagGray,
      image: image7,
    },
  ],

  subfunc: {
    title: '機能概要',
    desc: '歩行者の安全を守ることで効率が向上し、損害を軽減します。ORBROは都市環境や危険交差点に特化した安全機能を備えています。',
    data: [
      {
        icon: IconSearch,
        title: '複数対象の認識',
        desc: '子ども、ベビーカー、自転車、キックスクーターなど多様な対象を正確に同時検出します。',
      },
      {
        icon: IconRoute,
        title: 'リアルタイム位置・軌跡追跡',
        desc: '各対象の位置、速度、方向をリアルタイムで監視します。',
      },
      {
        icon: IconAnalytics,
        title: '衝突リスク評価アルゴリズム',
        desc: '距離や交差軌道から衝突の可能性を精密に算出します。',
      },
      {
        icon: IconChartBar,
        title: '双方向警告システム',
        desc: 'ドライバーにはLED、歩行者には音声による即時警告を行います。',
      },
      {
        icon: IconLayers,
        title: '死角補完',
        desc: '交差点や見通しの悪い場所でも歩行者を検出可能です。',
      },
      {
        icon: IconAnalytics,
        title: '精密な警告閾値設定',
        desc: '距離や速度のしきい値を調整し、誤警報を抑制します。',
      },
      {
        icon: IconLayers,
        title: 'オンプレミスによるデータセキュリティ',
        desc: 'データを外部に送信せず現場で処理し、セキュリティを強化します。',
      },
      {
        icon: IconSearch,
        title: 'CCTVとの簡単連携',
        desc: '多くのカメラメーカーに対応し、既存設備に容易に組み込めます。',
      },
    ],
  },

  system: {
    title: 'システム構成',
    img: rtlsSystem,
  },

  productTitle: '製品ラインナップ',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
